import React, { useRef, useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FileCopyOutlined } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { PasslyTooltip } from '@app/componentsV2';

interface IProps {
    valueToCopy: string;
    hovered?: boolean;
    children?: JSX.Element;
    // pre-translated tooltip
    tooltip?: string;
    className?: string;
    fetchBeforeCopy?: () => Promise<string>;
}

const fallbackCopyTextToClipboard = (text: string) => {
    let textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        let successful = document.execCommand('copy');
        let msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
};

function copyTextToClipboard(text: string) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}

export const CopyComponent = (props: IProps) => {
    const { translation } = useTypedTranslation();
    const copyRef = useRef<any>();
    const { valueToCopy, fetchBeforeCopy } = props;
    const [value, setValue] = useState<string>(props.tooltip === undefined ? translation('COPY_TO_CLIPBOARD') : props.tooltip);

    const setCopied = () => setValue(translation('COPIED'));
    const onMouseLeave = (e: any) => {
        e.preventDefault();

        setTimeout(() => {
            setValue(props.tooltip === undefined ? translation('COPY_TO_CLIPBOARD') : props.tooltip);
        }, 250);
    };

    const fetchAndClick = async (e: any) => {
        if (fetchBeforeCopy) {
            const text = await fetchBeforeCopy();

            copyTextToClipboard(text);
            setCopied();
        }
    };

    return (
        <div className={props.className} onMouseLeave={(e) => onMouseLeave(e)} onClick={!fetchBeforeCopy ? setCopied : undefined}>
            <PasslyTooltip title={value}>
                {!fetchBeforeCopy ? (
                    <CopyToClipboard text={valueToCopy} ref={copyRef}>
                        {props.children === undefined ? (
                            <IconButton>
                                <FileCopyOutlined className='tablev2__rowIconHoverStyle' color='inherit' fontSize='small' />
                            </IconButton>
                        ) : (
                            props.children
                        )}
                    </CopyToClipboard>
                ) : (
                    <IconButton onClick={fetchAndClick}>
                        <FileCopyOutlined className='tablev2__rowIconHoverStyle' color='inherit' fontSize='small' />
                    </IconButton>
                )}
            </PasslyTooltip>
        </div>
    );
};
